<template>
  <span @click.stop.prevent="clipboard">
    <el-button v-if="button" type="primary" :size="size">
       <i class="el-icon-copy-document" />
    </el-button>

    <template v-else>
      {{ value }}
      <span v-if="copied" class="copied">Copied!</span>
      <i v-else class="text el-icon-copy-document" />
    </template>

    <input type="hidden" :id="id" :value="value" />
  </span>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'clipboard'
    },
    button: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium'
    },
    value: String
  },
  data () {
    return {
      copied: false
    }
  },
  methods: {
    clipboard () {
      const elt = document.getElementById(this.id)
      elt.setAttribute('type', 'text')
      elt.select()

      try {
        this.copied = document.execCommand('copy')
      } catch (err) {
        console.error(err)
      }

      elt.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
      window.setTimeout(() => {
        this.copied = false
      }, 650)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../theme";

  span {
    cursor: pointer;

    .copied {
      color: $--color-primary;
      font-size: 11px;
    }
    .text.el-icon-copy-document {
      display: none;
    }
    &:hover .text.el-icon-copy-document {
      display: inline;
    }
  }
</style>
